<template>
  <div class="m3phkn-step">
    <ol class="m3phkn-step__flow">
      <li
        v-for="meta in routeMetas"
        :key="meta.order"
        :class="className(meta.order)"
      >
        <span>{{meta.subject}}</span>
      </li>
    </ol>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();

const routeMetas = computed(() => router.options.routes.map(route => route.meta));
const className = (stepNumber) => {
  if (route.meta.order === stepNumber) {
    return 'active';
  } else if (route.meta.order > stepNumber) {
    return 'complete';
  } else {
    return '';
  }
}
</script>